@if (is_loading) {
  <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
}


<div style="margin: 0px;">
  @if (myForm) {
  <form [formGroup]="myForm" (ngSubmit)="onSubmit()" novalidate>




      <div [hidden]="is_loading">

        <mat-card style="width: 400px; margin-top: 20px; margin-left: 20px;">
          <mat-card-header>
            <h2>Ad</h2>
          </mat-card-header>

          <mat-card-content>
            <mat-form-field style="margin-top: 15px; width: 100%">
              <mat-label>Ad Name:</mat-label>
              <input matInput type="text" placeholder="e.g. foo" (focus)="onFocus()" formControlName="name">
              <mat-error style="font-size: 12px">Valid name required</mat-error>
            </mat-form-field>

            @if (adgroup_type=='sms') {

            <mat-form-field style="margin-top: 15px; width: 100%">
              <mat-label>SMS Text:</mat-label>
              <input matInput type="text" placeholder="e.g. foo" (focus)="onFocus()" formControlName="sms_text">
              <mat-error style="font-size: 12px">Valid name required</mat-error>
            </mat-form-field>


<!--              <div style="margin-top: 15px; width: 100%">-->
<!--                <mat-slide-toggle formControlName="is_dummy_ad" (change)="onFocus()">-->
<!--                  {{ myForm.get('is_dummy_ad')?.value === true? 'Active' : 'Paused' }}-->
<!--                </mat-slide-toggle>-->
<!--              </div>-->



            }




            @if (adgroup_type.startsWith('image_')) {


              <mat-form-field style="margin-top: 15px; width: 100%">
                <mat-label>Redirect URL:</mat-label>
                <input matInput type="text" placeholder="e.g. foo" (focus)="onFocus()" formControlName="redirect_url">
                <mat-error style="font-size: 12px">Valid name required</mat-error>
              </mat-form-field>

              <!--ONLY ON CREATE-->
              @if (this.submit_text!='Edit') {
                <mat-form-field appearance="outline" style="margin-top:15px; width:100%">
                  <mat-label>Upload PNG</mat-label>
                  <input matInput [value]="selectedFileName || ''" placeholder="Choose a file…" readonly>
                  <button mat-button matSuffix type="button" (click)="fileInput.click()">Browse</button>
                  <mat-hint>Only .png, .gif files allowed</mat-hint>
                </mat-form-field>

                  <input #fileInput type="file" accept="image/png,image/gif" (change)="onPngSelected($event)" hidden>

                  @if (previewUrl) {
                    <div style="margin-top:10px; text-align:center;">
                      <img [src]="previewUrl" alt="Preview" style="max-width:100%; border-radius:4px; box-shadow:0 0 4px rgba(0,0,0,0.2);" />
                    </div>
                  }
              }


              <!--ONLY ON EDIT-->
              @if (image_url) {
                <img [src]="image_url" alt="Preview" style="max-width:100%; border-radius:4px; box-shadow:0 0 4px rgba(0,0,0,0.2);" />
              }
            }  <!--end image adgroup_type-->



            <div style="margin-top: 15px; width: 100%">
              <mat-slide-toggle formControlName="status" (change)="onFocus()">
                {{ myForm.get('status')?.value === true? 'Active' : 'Paused' }}
              </mat-slide-toggle>
            </div>

            <div style="margin-top: 15px; width: 100%">
              <mat-checkbox formControlName="is_dummy_ad" (change)="onDummyAdChange()">
                Dummy Ad
              </mat-checkbox>
            </div>

          </mat-card-content>

          <mat-card-actions>
            <div class="flex-container" style="margin-top: 10px;">
              <button mat-raised-button color="primary" [disabled]="!myForm.valid || is_loading" type="submit" style="margin: 15px">{{submit_text}}</button>
              <button mat-raised-button color="accent" [disabled]="is_loading" type="button" (click)="backToAds()" style="margin: 15px">Cancel</button>
            </div>
          </mat-card-actions>





        </mat-card>



      </div>










  </form>
  }
</div>



